import { AlphaKIcon } from './AlphaKIcon';

/**
 * author: GreenTurtwig
 * id 358C06F7-7E39-4023-A9FC-2C02F275B84B
 * name alpha-k
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-k.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetKIcon = AlphaKIcon;
export default AlphabetKIcon